module.exports = __webpack_public_path__ + "img/about_plan_inactive.f1a2499a.svg";